export const SITE_WORKING_CONDITION_ACQUISITION_MODULATORS_TABLE_FRENCH_LOCALE = {
  headers: {
    acqRate: "Taux d'acquisition",
    modulatorCsId: "Modulateur Cs Id",
    modulatorHwId: "Modulateur Hw Id",
    lastConnectionDate: "Date de dernière connexion",
    lastPointDate: "Date du dernier point",
    modulationPerformancePercentage: "Performance à la modulation",
    modulationCount: "Nombre de modulations",
    linkCsId: "Link Cs Id",
    applianceName: "Appareil",
    linkName: "Link",
    modulatorName: "Modulateur",
  },
  empty: "Aucun modulateur",
};
